import { queryProcedureResult } from 'iguazu-rpc';
import redirect from './redirect';
import { generateOneLoginDestinationUrl } from './generateOneLoginDestinationUrl';
import { ROUTE_ERROR, READ_USER_SESSION_V1_FUNCTION } from '../constants';

const onEnterCheckbookOrder =
  (store) => async (nextState, replace, callback) => {
    const { promise } = store.dispatch(
      queryProcedureResult({
        procedureName: READ_USER_SESSION_V1_FUNCTION,
        args: {
          body: JSON.stringify({}),
        },
      })
    );

    try {
      const response = await promise;

      // user is unauthenticated
      if (response.status === 401 || response.status === 400) {
        const browserOrigin = store
          .getState()
          .getIn(['browser', 'location', 'origin']);
        const oneLoginUrl = store.getState().getIn(['config', 'oneLoginUrl']);
        const loginUrl = generateOneLoginDestinationUrl(
          oneLoginUrl,
          browserOrigin,
          nextState.location.pathname
        );
        redirect(loginUrl, replace);
      }
    } catch (err) {
      redirect(ROUTE_ERROR, replace);
    }
    callback();
  };

export default onEnterCheckbookOrder;
